import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const faqData = [
  {
    question:
      "How can DailyPay help us stand out as an employer in the restaurant and QSR industry?",

    answer:
      "DailyPay can help you stand out among your competition in the restaurant and QSR industry. According to DailyPay research, job listings that mention on-demand pay through DailyPay fill open positions in half the time as those that don’t.",
  },

  {
    question: "How can DailyPay help us fill shifts?",

    answer:
"In addition to filling job listings in half the time with DailyPay, employee retention rates increase up to 72%, helping to reduce staffing shortages.  ",
  },

  {
    question:
      "How can DailyPay help with time clock compliance in the restaurant and QSR industry?",

    answer:
"In order to use DailyPay and make transfers, users need to correctly clock their hours. DailyPay has seen that employees who use our products are much more diligent about inputting hours. This means that your payroll team will spend less time processing costly off-cycle payments. ",
  },

  {
    question:
      "How many employees does my company need to have to offer DailyPay?",

    answer:
"Currently, DailyPay is only available to companies with 500 or more employees.",  },

  {
    question:
      "What’s the average cost per hire in the restaurant industry?",

    answer:
"The estimated cost for replacing an employee is 1.5-2 times the employee’s salary.",  
},

  {
    question:
      "What’s the average restaurant turnover rate?",

    answer:
   "The QSR and wider restaurant industry suffer from one of the highest turnover rates across industries at 144%.",
  },

  {
   question:
   "How can restaurants improve employee retention?",
   answer:
   "Restaurants can improve employee retention through higher compensations and desirable benefits such as on-demand pay."
  },
];

const EMP_RestaurantFAQ = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="w-full bg-white py-14 sm:py-16 md:py-20 lg:py-24">

      <div
        className="
          lg:max-[1400px]
          mx-auto
          px-4
          sm:px-6
          md:px-10
          lg:px-16
        "
      >

        {/* ================= HEADING ================= */}

        <h2
          className="
            text-center
            text-[#220000]
            font-serif
            font-medium
            leading-[1.1]
            text-[26px]
            sm:text-[42px]
            md:text-[54px]
            lg:text-[38px]
            lg:font-extralight
            lg:-mt-[50px]
          "
        >
          Have Questions? We Have Answers.
        </h2>

        {/* ================= FAQ CONTAINER ================= */}

        <div className="mt-12 sm:mt-14 md:mt-16 lg:ml-[50px] max-w-[1280px]">

          {faqData.map((item, index) => (
            <div
              key={index}
              className="
                border-t
                border-[#dddddd]
              "
            >

              {/* ================= QUESTION ================= */}

              <button
                onClick={() => toggleFAQ(index)}
                className="
                  w-full
                  flex
                  items-center
                  justify-between
                  gap-6
                  text-left
                  py-7
                  sm:py-8
                "
              >

                <h3
                  className="
                    text-black
                    font-semibold
                    leading-[1.5]
                    text-[16px]
                    font-sans
                    sm:text-[20px]
                    md:text-[24px]
                    lg:text-[16px]
                    lg:font-serif
                    max-w-[92%]
                  "
                >
                  {item.question}
                </h3>

                {/* ICON */}
                <div className="flex-shrink-0">

                  {activeIndex === index ? (
                    <ChevronUp
                      size={26}
                      className="text-black"
                    />
                  ) : (
                    <ChevronDown
                      size={26}
                      className="text-black"
                    />
                  )}

                </div>

              </button>

              {/* ================= ANSWER ================= */}

              <div
                className={`
                  overflow-hidden
                  transition-all
                  duration-500
                  ease-in-out

                  ${
                    activeIndex === index
                      ? "max-h-[500px] opacity-100 pb-8"
                      : "max-h-0 opacity-0"
                  }
                `}
              >

                <p
                  className="
                    text-black
                    leading-[1.7]
                    text-[16px]
                    sm:text-[19px]
                    md:text-[22px]
                    lg:text-[18px]
                    lg:font-sans
                    max-w-[700px]
                  "
                >
                  {item.answer}
                </p>

              </div>

            </div>
          ))}

          {/* LAST BORDER */}
          <div className="border-t border-[#dddddd]"></div>

        </div>

      </div>

    </section>
  );
};

export default EMP_RestaurantFAQ;